import {SYSTEM} from "../constants/sessionActionTypes";

const closeApp = () => ({type: SYSTEM.CLOSE_APP})

export {
  closeApp,
}
